import list from "./list";
import fetchingNext from "./fetchingNext";
import subtypes from "./subtypes";
import filters from "./filters";
import menuItems from "./menuItems";

export default {
  list,
  fetchingNext,
  subtypes,
  filters,
  menuItems,
};



// WEBPACK FOOTER //
// ./assets/list/reducers/index.js